// The "Your notes" section's two view rules, shared by both task drill-ins and mirrored by iOS
// `TaskScreen.showsNotesSection` / Android `taskShowsNotesSection`. Import-free so it unit-tests alone.

/** Whether "Your notes" renders: always while the task can take a note, and on a settled task only when
 *  there is a note to read — a finished task with none has nothing to show and nothing to offer. */
export function showsNotesSection(noteCount: number, editable: boolean): boolean {
  return editable || noteCount > 0;
}

/** The composer's placeholder names the agent that will read the note, when the drill-in knows it. */
export function notePlaceholder(t: (key: string, vars?: Record<string, string>) => string, agentName: string): string {
  const name = agentName.trim();
  return name ? t('tasks.notes.placeholderNamed', { agent: name }) : t('tasks.notes.placeholder');
}
